import ProductPlaceholder from '../../assets/images/placeholder-product.svg'

export function validateImageExtension(imageURL: string) {
	if (/\.(jpeg|jpg|png|gif)\b/i.test(imageURL)) return imageURL

	return ProductPlaceholder
}
